<template>
    <div id="app">
		<my-navbar activeIndex="1" :bgc="bgc" />
        <router-view></router-view>
		 <my-footer />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
			bgc:"#000000"
		}
    },
}
</script>

<style lang="scss" scoped>
@import './assets/css/reset.css';
@import './assets/css/element-theme/index.css';
</style>
